import {
  MY_VENDORS_TAB_LISTS,
} from "../utils/myVendorsFilterOptions";
import {
  VENDOR_STICKY_SCREEN_KEYS,
  loadMyVendorsStickyFilterState,
} from "../utils/vendorStickyFilterPersistence";
import useStickySelectedIds from "./useStickySelectedIds";

/** Resolves the sessionStorage key for My Vendors sticky filters by active tab. */
export function getMyVendorsStickyScreenKey(activeTab) {
  return activeTab === MY_VENDORS_TAB_LISTS
    ? VENDOR_STICKY_SCREEN_KEYS.MY_VENDORS_LISTS
    : VENDOR_STICKY_SCREEN_KEYS.MY_VENDORS_MINE;
}

/**
 * Sticky selectedIds for My Vendors page (mine vs lists tabs).
 */
export default function useMyVendorsPageStickyFilters(activeTab) {
  return useStickySelectedIds(
    getMyVendorsStickyScreenKey(activeTab),
    loadMyVendorsStickyFilterState
  );
}
